import {
    CustomersInsuranceResponse,
    ICustomersInsuranceManualResponse,
    ICustomersInsuranceUploadResponse
} from '@/shared/endpoints/customers/models/response';
import DocumentImage from '../document-image';

interface IProps {
    className?: string;
    hasDelete?: boolean;
    insurance: CustomersInsuranceResponse;
    onDelete?(insurance: CustomersInsuranceResponse): void;
}

export const InsuranceListItem = ({ className = '', hasDelete, insurance, onDelete }: IProps) => {
    const uploadInsurance = insurance as ICustomersInsuranceUploadResponse;

    const commonClassName =
        `xl-max:w-full relative px-11 py-7.5 ${className || 'w-[438px] 3xl:w-[540px]'} max-w-[100%] border-[0.5px] shadow-modal border-black rounded-[13px] flex flex-col`;
    const deleteClassName =
        'cursor-pointer text-base text-primary-800 bg-mint-400 icon-bin rounded-full absolute right-4 w-[35px] h-[35px] flex justify-center items-center insurance__delete_btn';

    if (uploadInsurance.front && uploadInsurance.back)
        return (
            <div className={`${commonClassName} ${className}`} data-testid='insurance-upload-data'>
                {hasDelete && <i className={deleteClassName} onClick={() => onDelete?.(uploadInsurance)} />}

                <h4 data-testid="insurance-upload-front-title" className="font-atkinsonHyperlegible text-black text-base font-bold mb-2">Front:</h4>
                <div className="w-full h-[160px] border-1 rounded-10 mb-6">
                    <DocumentImage testId="insurance-upload-front-document" path={uploadInsurance.front.path} bg className="w-full h-full" />
                </div>

                <h4 data-testid="insurance-upload-back-title" className="font-atkinsonHyperlegible text-black text-base font-bold mb-2">Back:</h4>
                <div className="w-full h-[160px] border-1 rounded-10 mb-6">
                    <DocumentImage testId="insurance-upload-back-document" path={uploadInsurance.back.path} bg className="w-full h-full" />
                </div>
            </div>
        );

    const manualInsurance = insurance as ICustomersInsuranceManualResponse;

    return (
        <div className={`${commonClassName} ${className}`} data-testid='insurance-manual-data'>
            {hasDelete && <i className={deleteClassName} onClick={() => onDelete?.(manualInsurance)} />}
            <div className="mb-3">
                <h4 className="font-atkinsonBold text-black sm-max:text-[0.8125rem] text-base mb-0.5" data-testid="insurnace-id-number">ID Number</h4>
                <p className="font-atkinsonBold text-primary-400 text-xl sm-max:text-base text-ellipsis overflow-hidden" data-testid="insurnace-id-number-value">
                    {manualInsurance.cardHolderID}
                </p>
            </div>
            <div className="mb-3">
                <h4 className="font-atkinsonBold text-black sm-max:text-[0.8125rem] text-base mb-0.5" data-testid="insurnace-rx-group">Rx Group</h4>
                <p className="font-atkinsonBold text-primary-400 text-xl sm-max:text-base text-ellipsis overflow-hidden" data-testid="insurnace-rx-group-description">
                    {manualInsurance.groupID || '-'}
                </p>
            </div>
            <div className="flex justify-between overflow-hidden">
                <div className="max-w-[50%]">
                    <h4 className="font-atkinsonBold text-black sm-max:text-[0.8125rem] text-base mb-0.5" data-testid="insurnace-rx-bin">Rx BIN</h4>
                    <p className="font-atkinsonBold text-primary-400 text-xl sm-max:text-base text-ellipsis overflow-hidden" data-testid="insurnace-rx-bin-value">
                        {manualInsurance.provider.bin}
                    </p>
                </div>
                <div className="max-w-[50%]">
                    <h4 className="font-atkinsonBold text-right text-black sm-max:text-[0.8125rem] text-base mb-0.5" data-testid="insurnace-rx-pcn">Rx PCN</h4>
                    <p className="font-atkinsonBold text-right text-primary-400 text-xl sm-max:text-base text-ellipsis overflow-hidden" data-testid="insurnace-rx-pcn-value">
                        {manualInsurance.provider.pcn}
                    </p>
                </div>
            </div>
        </div>
    );
};
